module.exports = __webpack_public_path__ + "media/images/global/accordions/remove-97ec4bac1824f8b97345aebe49c52c3f.png";